import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logoutSession } from './session';
import { useAuth } from './auth';
import { BrandLogo } from './components/BrandLogo';

const navigation = [
  ['Overview', '/'],
  ['Agents', '/agents'],
  ['Knowledge', '/knowledge'],
  ['Conversations', '/conversations'],
  ['Leads', '/leads'],
  ['Handoffs', '/handoffs'],
  ['Members', '/members'],
  ['Audit log', '/audit'],
  ['Settings', '/settings'],
];

export function AppLayout() {
  const { user, loading } = useAuth();
  const client = useQueryClient();
  const logout = useMutation({
    mutationFn: () => logoutSession(client),
  });
  if (loading)
    return (
      <main className="center" role="status">
        Loading workspace…
      </main>
    );
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="shell">
      <aside>
        <BrandLogo />
        <div className="tenant">
          <small>Workspace</small>
          <strong>{user.tenantName}</strong>
        </div>
        <nav aria-label="Main navigation">
          {navigation.map(([label, href]) => (
            <NavLink key={href} to={href!} end={href === '/'}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="account">
          <div>
            <strong>{user.displayName}</strong>
            <small>{user.role}</small>
          </div>
          <button className="ghost" disabled={logout.isPending} onClick={() => logout.mutate()}>
            {logout.isPending ? 'Signing out…' : 'Sign out'}
          </button>
        </div>
        {logout.error && (
          <p className="form-error" role="alert">
            Could not sign out. Check your connection and try again.
          </p>
        )}
      </aside>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
